import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { RootState } from "store/rootReducer";
import { API_URL } from "config";
import userStorage from "store/UserStorage";
import { batch } from "react-redux";
import { setResponseMessage } from "../adminSlice";
import { InstallationAdminState } from "./types";

const initialState: InstallationAdminState = {
  installations: [],
  installation: undefined,
  loading: false,
};

const installationAdmin = createSlice({
  name: "installationAdminSlice",
  initialState,
  reducers: {
    setInstallations(state, action) {
      state.installations = action.payload;
    },

    setInstallation(state, action) {
      state.installation = action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
  },
});
export const {
  setLoading,
  setInstallations,
  setInstallation,
} = installationAdmin.actions;
export const selectLoading = (state: RootState) =>
  state.installationAdmin.loading;
export const selectInstallation = (state: RootState) =>
  state.installationAdmin.installation;

export const selectAllInstallations = (state: RootState) =>
  state.installationAdmin.installations;

export const fetchAllInstallations = () => async (dispatch: any) => {
  try {
    dispatch(setLoading(true));
    const result = await axios.get(`${API_URL}/admin/installations`);
    batch(() => {
      dispatch(setInstallations(result.data.data));
      dispatch(setResponseMessage({ message: "", hasError: false }));
      dispatch(setLoading(false));
    });
  } catch (error: any) {
    batch(() => {
      dispatch(setResponseMessage({ message: error.message, hasError: true }));
      dispatch(setLoading(false));
    });

    console.log(`Error in fetchAllTags: ${error.message}`);
  }
};

export const fetchInstallation = (id: string) => async (dispatch: any) => {
  try {
    dispatch(setLoading(true));
    const result = await axios.get(
      `${API_URL}/admin/installation-values/${id}`
    );
    batch(() => {
      dispatch(setInstallation(result.data.data));
      dispatch(setResponseMessage({ message: "", hasError: false }));
      dispatch(setLoading(false));
    });
  } catch (error: any) {
    batch(() => {
      dispatch(setResponseMessage({ message: error.message, hasError: true }));
      dispatch(setLoading(false));
    });

    console.log(`Error in fetchAllTags: ${error.message}`);
  }
};

export const addInstallation = (
  data: any,
  onUploadProgress: (e: ProgressEvent<EventTarget>) => void
) => async (dispatch: any) => {
  try {
    dispatch(setLoading(true));
    const json = JSON.stringify(data);

    let token = userStorage.getUser();
    const response = await axios.post(
      `${API_URL}/admin/installations`,
      { data: json },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        onUploadProgress,
      }
    );
    dispatch(
      setResponseMessage({
        message: "Успешно създадохте монтажа.",
        hasError: false,
      })
    );
  } catch (error: any) {
    batch(() => {
      dispatch(setResponseMessage({ message: error.message, hasError: true }));
      dispatch(setLoading(false));
    });
  }
};

export const updateInstallation = (
  data: any,
  onUploadProgress: (e: ProgressEvent<EventTarget>) => void
) => async (dispatch: any) => {
  try {
    dispatch(setLoading(true));
    const json = JSON.stringify(data);

    let token = userStorage.getUser();
    const response = await axios.put(
      `${API_URL}/admin/installations/${data.id}`,
      { data: json },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        onUploadProgress,
      }
    );
    dispatch(
      setResponseMessage({
        message: "Успешно променихте монтажа.",
        hasError: false,
      })
    );
  } catch (error: any) {
    batch(() => {
      dispatch(setResponseMessage({ message: error.message, hasError: true }));
      dispatch(setLoading(false));
    });

    //  console.log(`Error in addProduct: ${error.message}`);
  }
};

export const deleteInstallation = (id: string) => async (dispatch: any) => {
  try {
    let token = userStorage.getUser();
    const response = await axios.delete(
      `${API_URL}/admin/installations/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    batch(() => {
      dispatch(
        setResponseMessage({
          message: "Успешно изтрихте монтажа.",
          hasError: false,
        })
      );
      dispatch(fetchAllInstallations());
    });
  } catch (error: any) {
    batch(() => {
      dispatch(setResponseMessage({ message: error.message, hasError: true }));
      dispatch(setLoading(false));
    });

    //  console.log(`Error in deleteProduct: ${error.message}`);
  }
};

export default installationAdmin.reducer;
